/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_Item_RectificationInputs */

const en_privacy_rights_item_rectification = /** @type {(inputs: Privacy_Rights_Item_RectificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right to rectification`)
};

const de_privacy_rights_item_rectification = /** @type {(inputs: Privacy_Rights_Item_RectificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recht auf Berichtigung`)
};

const fr_privacy_rights_item_rectification = /** @type {(inputs: Privacy_Rights_Item_RectificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droit de rectification`)
};

const es_privacy_rights_item_rectification = /** @type {(inputs: Privacy_Rights_Item_RectificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derecho de rectificación`)
};

const it_privacy_rights_item_rectification = /** @type {(inputs: Privacy_Rights_Item_RectificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diritto di rettifica`)
};

const nl_privacy_rights_item_rectification = /** @type {(inputs: Privacy_Rights_Item_RectificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recht op rectificatie`)
};

const pl_privacy_rights_item_rectification = /** @type {(inputs: Privacy_Rights_Item_RectificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prawo do sprostowania`)
};

const fi_privacy_rights_item_rectification = /** @type {(inputs: Privacy_Rights_Item_RectificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oikeus tietojen oikaisemiseen`)
};

const da_privacy_rights_item_rectification = /** @type {(inputs: Privacy_Rights_Item_RectificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ret til berigtigelse`)
};

const sv_privacy_rights_item_rectification = /** @type {(inputs: Privacy_Rights_Item_RectificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rätt till rättelse`)
};

/**
* | output |
* | --- |
* | "Right to rectification" |
*
* @param {Privacy_Rights_Item_RectificationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_item_rectification = /** @type {((inputs?: Privacy_Rights_Item_RectificationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_Item_RectificationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_rights_item_rectification(inputs)
	if (locale === "fr") return fr_privacy_rights_item_rectification(inputs)
	if (locale === "es") return es_privacy_rights_item_rectification(inputs)
	if (locale === "it") return it_privacy_rights_item_rectification(inputs)
	if (locale === "nl") return nl_privacy_rights_item_rectification(inputs)
	if (locale === "pl") return pl_privacy_rights_item_rectification(inputs)
	if (locale === "fi") return fi_privacy_rights_item_rectification(inputs)
	if (locale === "da") return da_privacy_rights_item_rectification(inputs)
	if (locale === "sv") return sv_privacy_rights_item_rectification(inputs)
	return en_privacy_rights_item_rectification(inputs)
});